import { useEffect } from 'react';

/** Injects a <script type="application/ld+json"> block into <head>, removing it on unmount. Pass `null` to skip. */
export function useJsonLd(id: string, data: object | null) {
  useEffect(() => {
    if (!data) return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-jsonld-id', id);
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [id, data]);
}
